<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
@if (shellState$ | async; as shellState) {
  <div
    class="flex flex-row justify-between lg:gap-10 lg:justify-start items-center py-3 lg:py-4 lg:px-4"
  >
    <div class="text-lg lg:text-2xl tracking-widest font-campan font-medium">
      {{ theaterName }}
    </div>
    <a
      class="flex flex-row items-center gap-2 py-1 lg:border-b border-white"
      [routerLink]="[
        shellState.shows?.[theater]?.[0]?.location?.page?.url ?? '#',
      ]"
      (click)="dispatchShowLinkClicked()"
      [attr.cdkFocusInitial]="initialFocus ? '' : null"
      ><span
        class="text-xxs uppercase tracking-widest font-light lg:font-medium"
        >View Theater Details</span
      >
      <img
        src="/assets/icons/right-arrow-icon.svg"
        class="w-5 lg:w-6"
        alt="live shows"
    /></a>
  </div>
  <hr class="ss-divider lg:hidden" />
  <div
    class="w-full flex flex-row gap-4 lg:gap-10 mb-8 lg:mb-0 py-4 lg:px-4 lg:pt-0 overflow-x-auto"
  >
    @for (
      show of shellState.shows?.[theater];
      track showTrackBy($index, show)
    ) {
      <div class="relative flex flex-col items-center">
        <a
          class="relative w-36"
          [routerLink]="[show.page?.url ?? '#']"
          (click)="dispatchShowLinkClicked()"
        >
          @if (show.showImage?.id) {
            <img
              class="rounded-xl"
              width="144"
              height="132"
              [ngSrc]="show.showImage!.id"
              [loaderParams]="{
                modifiedDate: show.showImage?.modified_on,
              }"
              alt="{{ show.showImage?.title ?? 'Show image' }}"
            />
          }
          <div
            class="absolute bottom-0 left-0 right-0 h-11 px-1 flex flex-col justify-center bg-gradient-to-t from-ss-www-background lg:from-black to-transparent"
          >
            <span
              class="uppercase text-[14px] font-medium text-center leading-[16px] tracking-[1.12px]"
              >{{ show.description }}</span
            >
          </div>
        </a>
        <a
          [routerLink]="[show.page?.url ?? '#']"
          (click)="dispatchShowLinkClicked()"
          class="text-xxs tracking-widest uppercase py-1 border-b border-white pt-4 font-medium"
          >Show details</a
        >
      </div>
    }
  </div>
}
